import { render, staticRenderFns } from "./CopyTemplateModal.vue?vue&type=template&id=5e400d88&scoped=true"
import script from "./CopyTemplateModal.vue?vue&type=script&lang=js"
export * from "./CopyTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./CopyTemplateModal.vue?vue&type=style&index=0&id=5e400d88&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e400d88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e400d88')) {
      api.createRecord('5e400d88', component.options)
    } else {
      api.reload('5e400d88', component.options)
    }
    module.hot.accept("./CopyTemplateModal.vue?vue&type=template&id=5e400d88&scoped=true", function () {
      api.rerender('5e400d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/CopyTemplateModal.vue"
export default component.exports